import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import { get_token } from "@/router";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

export default {
  components: {
    Sidebar,
    Navbar,
    InactivityModal
  },
  data() {
    return ({
      isLoading: false,
      businesses: [],
    });
  },

  methods: {

    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    fetch_businesses() {
      this.isLoading = true;
      return new Promise(() => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_company_profile/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          success: (data) => {
            this.businesses = data.data || [];
            this.$nextTick(() => {
              $('.table').DataTable().destroy();
              $('.table').DataTable({
                paging: true,
                searching: true,
                ordering: true,
                info: true,
                lengthChange: true,
                pageLength: 10,
                language: {
                  paginate: {
                    previous: "Previous",
                    next: "Next"
                  },
                  info: "Showing _START_ to _END_ of _TOTAL_ entries",
                  infoEmpty: "No entries available"
                }
              });
            });
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      });
    },
    
    view_profile(profile){
        const base = profile.base_profile.id;
        const type = profile.base_profile.profile_type;
        window.location.href = `/customer_profile?base=${base}&type=${type}`;
      },
  },
  mounted() {
    this.fetch_businesses();
  }
};
